export default __webpack_public_path__ + "static/media/ancient-one.9ddbc3c8.mp3";